// Dependencies
import Cookies from 'js-cookie';
import { atom, selector } from 'recoil';

// Functions
import { apiUser } from '@api/common';

// Utils
import { caseChange } from '@utils/helpers';

// Constants
import { isStudent, isStaff } from '@constants/index';

export const userState = atom<User | null | any>({
  key: 'userState',
  default: null,
  effects_UNSTABLE: [
    ({ node, onSet, resetSelf, setSelf, trigger }) => {
      onSet((newUser, oldUser) => {
        if (newUser === null) {
          const roleSlug = caseChange(oldUser?.role.slug);
          Cookies.remove(`${roleSlug}Token`);
          Cookies.remove(`${roleSlug}RefreshToken`);
          Cookies.remove('currentRole');
          Cookies.remove('currentRoleId');
        } else if (typeof newUser === 'object') {
          if (newUser.token) {
            const roleSlug = caseChange(newUser.role.slug);
            Cookies.set(`${roleSlug}Token`, newUser.token, { sameSite: 'strict' });
            Cookies.set(`${roleSlug}RefreshToken`, newUser.refreshToken, { sameSite: 'strict' });
            Cookies.set('currentRole', newUser.role.slug, { sameSite: 'strict' });
            Cookies.set('currentRoleId', `${newUser.role.id}`, { sameSite: 'strict' });
          }
        }
      });
    },
  ],
});

export const userSetter = selector<User | null>({
  key: 'userSetter',
  get: ({ get }) => {
    console.warn('Use userState, and not userSetter to access the current User');
    return get(userState);
  },
  set: ({ set }, user) => {
    if ('id' in user) {
      const _isStudent = user && isStudent(user.role_id);
      const isAdmin = user && isStaff(user.role_id);
      set(userState, user ? { ...user, isAdmin, isStudent: _isStudent } : null);
    }
  },
});

export const userSelector = selector<User | null>({
  key: 'userSelector',
  get: async ({ get }) => {
    if (Cookies.get('currentRole')) {
      const currentUser = get(userState);
      if (currentUser) return currentUser;
      const res = await apiUser.get.self();
      if (res.ok) return res.data;
      return null;
    }
    return null;
  },
  set: ({ set }, user) => {
    //@ts-ignore
    const isStudent = user && user.role_id === 8;
    const isAdmin = user && !isStudent;
    //@ts-ignore
    set(userState, { ...user, isAdmin, isStudent });
  },
});
